module.exports = __webpack_public_path__ + "static/media/gem-fragments.9fd00e01.svg";